import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, SimpleStringReply, NullReply, Command } from '@redis/client/dist/lib/RESP/types';
import { RedisJSON, transformRedisJsonArgument } from '@redis/client/dist/lib/commands/generic-transformers';

export interface JsonSetOptions {
  condition?: 'NX' | 'XX';
  /**
   * @deprecated Use `{ condition: 'NX' }` instead.
   */
  NX?: boolean;
  /**
   * @deprecated Use `{ condition: 'XX' }` instead.
   */
  XX?: boolean;
  /**
   * If set, forces Redis to use the specified floating-point type for storing all FP homogeneous arrays.
   * available since 8.8
   */
  fpha?: 'BF16' | 'FP16' | 'FP32' | 'FP64';
}

export default {
  IS_READ_ONLY: false,
  parseCommand(
    parser: CommandParser,
    key: RedisArgument,
    path: RedisArgument,
    json: RedisJSON,
    options?: JsonSetOptions
  ) {
    parser.push('JSON.SET');
    parser.pushKey(key);
    parser.push(path, transformRedisJsonArgument(json));

    if (options?.condition) {
      parser.push(options?.condition);
    } else if (options?.NX) {
      parser.push('NX');
    } else if (options?.XX) {
      parser.push('XX');
    }
    if (options?.fpha !== undefined) {
      parser.push('FPHA', options.fpha);
    }
  },
  transformReply: undefined as unknown as () => SimpleStringReply<'OK'> | NullReply
} as const satisfies Command;
